<template>
      <el-dialog
        :title="title"
        :visible.sync="visible"
        :before-close="closeDialog"
        width="1200px"
        class="multiList_dialog"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
      <div class="div_border" v-loading="loading">
        <div style="height: auto;display: inline-block;width: 100%;">
          <el-table v-loading="loading" :data="List" border :highlight-current-row="true">
            <el-table-column prop="id" :label="$t('TankService.Check')" width="70">
            <template slot-scope="scope">
              <div>
                <el-checkbox v-model="scope.row.selected" :key="scope.row.id" ></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="File_Name" :label="$t('TankService.FileName')" min-width="300" />
          <el-table-column prop="File_Type" :label="$t('TankService.FileType')" min-width="150" />
          <el-table-column prop="File_Url" :label="$t('TankService.Operation')" width="150">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="openModal(scope.row)">
                  {{ $t('TankService.Preview') }}
                </el-button>
                <el-button type="text" size="small" @click="dfLoad(scope.row)">
                  {{ $t('TankService.Download') }}
              </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <div v-if="isModalOpen" class="modal" @click.self="closeModal">
            <img :src="currentImageSrc" alt="Preview">
            <button class="close-button" @click="closeModal">{{ $t('TankService.Close') }}</button>
        </div>
      </div>
        <img :src="imageSrc" alt="Preview" style="display:none"/>
        <div slot="footer">
          <el-button type="primary" @click="selectAllItems(true)">{{ $t('TankService.SelectAll') }}</el-button>
          <el-button type="primary" @click="selectAllItems(false)">{{ $t('TankService.DeselectAll') }}</el-button>
          <el-button type="primary" @click="downloads">{{ $t('TankService.BatchDownload') }}</el-button>
          <el-button type="primary" @click="closeDialog">{{ $t('TankService.Close') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <script>
    import dialog from '@/components/fms/mixins/dialog'
    import { convertYMD } from '@/utils/index.js'
    import { getFileListByBookingNo, getTDFileListByBookingNo, getFileListByYardScheduleID, getFileBlob } from '@/api//gmsTank.js';
    import { ISStr } from '@/utils/isClass'
    import axios from 'axios';
    export default {
      components: {},
      mixins: [dialog],
      props: {
        curRow: {
          type: Object,
          default: () => {}
        },
        jobType: {
          type: String,
          default: 'OE'
        }
      },
      data() {
        return {
          lang: 'zh',
          loading: false,
          List: [],
          imageSrc: null,
          isModalOpen: false,
          currentImageSrc: '',
        }
      },
      computed: {},
      mounted() {
        this.lang = this.$ls.get('lang');
        this.load();

      },
      methods: {
        async load() {
            const data = {
            BookingNo: this.curRow.Booking_No,
            lang: this.lang
            };
            this.loading = true;
            var res = [];
            if (this.curRow.Job_Type === 'TE') {
            res = await getFileListByBookingNo(data);
            }
            if (this.curRow.Job_Type === 'TD') {
            res = await getTDFileListByBookingNo(data);
            }
            if (this.curRow.Job_Type === 'TY') {
            const data = {
            YardScheduleID: this.curRow.YardScheduleID,
            lang: this.lang
            };
            res = await getFileListByYardScheduleID(data);
            }
            this.loading = false;
            if (res && res.isSuccess) {
            this.List = res.data;
            }
        },
        formatterTime(row, column) {
          return convertYMD(row[column.property])
        },
        dfLoad(row) {
           getFileBlob({ Url: row.File_Url, lang: this.lang }).then((res) => {
            if (!ISStr(res.data)) {
            var fileContent = res.data; // 从后端获取的 byte[] 转换成的字符串
            // 将字符串转换为 byte[]
            var byteCharacters = atob(fileContent);
            var byteArray = new Uint8Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                  byteArray[i] = byteCharacters.charCodeAt(i);
            }
            // 创建 Blob 对象
            var blob = new Blob([byteArray], {
                  type: 'application/octet-stream',
            });
            this.DownloadItem(blob, row.File_Name);
            } else {
            // 获取文件地址信息失败，打开新页面显示附件
            const link = document.createElement('a');
            link.href = row.File_Url;
            link.download = row.File_Name;
            link.target = '_blank';
            link.click();
            }
            });
        },
        getBlob(url) {
          return new Promise((resolve) => {
            const xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = () => {
              if (xhr.status === 200) {
                const reader = new FileReader()
                reader.onload = (event) => {
                  try {
                    const content = this.decodeUnicode(
                      JSON.parse(event.target.result)
                    )
                    if (content.isSuccess === false) {
                      this.messagebox.alert(content.msg)
                    } else {
                      resolve(xhr.response)
                    }
                  } catch (error) {
                    resolve(xhr.response)
                  }
                }
                reader.readAsText(xhr.response)
              }
            }
            xhr.onerror = () => {
              console.log('请求异常：' + xhr.statusText)
            }
            xhr.send()
          })
        },
        DownloadItem(blob, fileName) {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
        },
        decodeUnicode(obj) {
          for (var key in obj) {
            if (typeof obj[key] === 'string') {
              obj[key] = unescape(obj[key].replace(/\\u/g, '%u'))
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
              this.decodeUnicode(obj[key])
            }
          }
          return obj
        },
        async loadImage(url) {
          try {
            await getFileBlob({ Url: url, lang: this.lang })
              .then((res) => {
                if (!ISStr(res.data)) {
                  var fileContent = res.data // 从后端获取的 byte[] 转换成的字符串
                  // 将字符串转换为 byte[]
                  var byteCharacters = atob(fileContent)
                  var byteArray = new Uint8Array(byteCharacters.length)
                  for (var i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i)
                  }
                  // 将byte[]数组转换为Base64字符串
                  const base64String = this.byteArrayToBase64(new Uint8Array(byteArray));

                  // 获取文件扩展名
                  const fileExtension = url?.split('.').pop().toLowerCase();
                  var imageSrc;
                  // 判断文件格式
                  if (fileExtension === 'jpg' || fileExtension === 'jpeg') {
                    imageSrc = `data:image/jpeg;base64,${base64String}`;
                  } else if (fileExtension === 'png') {
                    imageSrc = `data:image/png;base64,${base64String}`;
                  } else {
                    imageSrc = require('@/assets/fms/file.png');
                  }
                  this.currentImageSrc = imageSrc;
                }
              })
          } catch (error) {
            console.error('Error loading image:', error);
          }
        },
        /** 将byte[]数组转换为Base64字符串 */
        byteArrayToBase64(byteArray) {
          const binary = Array.from(byteArray).map(byte => String.fromCharCode(byte)).join('');
          return btoa(binary);
        },
        /** 全选单选 */
        selectAllItems(isSelected) {
          this.List.forEach(item => {
            this.$set(item, 'selected', isSelected);
          })
        },
        /** 批量下载 */
        downloads() {
          console.log(this.List.filter(x => x.selected === true), '批量下载')
          var data = this.List.filter(x => x.selected === true);
          data.forEach(item => { this.dfLoad(item) })
          // this.dfLoadList(data)
        },
        dfLoadList(row) {
          getFileBlobList({ CFSFileInfo: row }).then((res) => {
            if (!ISStr(res.data)) {
              var fileContent = res.data // 从后端获取的 byte[] 转换成的字符串
              // 将字符串转换为 byte[]
              var byteCharacters = atob(fileContent)
              var byteArray = new Uint8Array(byteCharacters.length)
              for (var i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i)
              }
              // 创建 Blob 对象
              var blob = new Blob([byteArray], { type: 'application/octet-stream' })
              this.DownloadItem(blob, 'CFS附件_' + this.curRow.Booking_No + '.zip')
            }
          })
        },
        openModal(data) {
          this.currentImageSrc = '';
          this.loadImage(data.File_Url);
          this.isModalOpen = true;
        },
        closeModal() {
          this.isModalOpen = false;
        },
      }
    }
    </script>
    <style scoped>
    .multiList_dialog {
        display: flex;
        overflow: hidden;
    }
    .multiList_dialog >>> .el-dialog {
        height: 80% !important;
    }
    .multiList_dialog >>> .el-dialog__header {
        height: 10% !important;
    }
    .multiList_dialog >>> .el-dialog__body {
        height: 80% !important;
        padding: 0px 20px 10px 20px !important;
    }
    .multiList_dialog >>> .el-dialog__footer {
        padding: 0px;
        padding-top: 0px;
        margin-right: 20px  !important;
        height: 10% !important;
    }
    .div_border {
        border-top-width: 1px;
        border-bottom-width: 1px;
        height: 100% !important;
        padding: 0px 10px 10px 10px;
        overflow-y: auto !important;
    }
    .div_List{
        float: left;
        margin-bottom: 20px;
        margin-left: 10px;
        display: flow-root;
        height: 250px;
        width: 200px;
    }
    .div-img{
      display: flex;
    }
    .div-img img {
      width: 200px;
      height: 200px;
    }
    .text-container {
      /* 设置容器高度和样式 */
      height: 2.2em;
      overflow: hidden;
      text-align: center; /* 水平居中 */
    }
    .text-content {
      display: -webkit-box; /* 使用 flexbox */
      -webkit-box-orient: vertical; /* 垂直方向 */
      -webkit-line-clamp: 2; /* 行数限制 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
    .order-text-type{
      font-size: 15px;
      font-family: Source Han Sans SC, Source Han Sans SC-Regular;
      font-weight: 400;
      text-align: left;
      line-height: 22px;
      background: #FDEDE6;
      color: #EB5C20;
      border-radius: 6px;
      padding: 2px 10px 2px 10px;
      width: 100%;
    }
    .modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999;
    }

    .modal img {
      max-width: 90%;
      max-height: 90%;
      margin: auto;
    }
    .close-button {
      position: absolute;
      top: 0;
      right: 0;
      background-color: transparent;
      border: none;
      color: white;
      font-size: 24px;
      cursor: pointer;
      padding: 10px;
      z-index: 1001; /* 确保按钮在图片上方 */
    }
    </style>
